// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { GRID_COLUMNS } from "../types";
/** A width the grid can draw: a whole number of columns from 1 to 12. */
export function clampWidth(width) {
    if (!Number.isFinite(width))
        return GRID_COLUMNS;
    return Math.min(GRID_COLUMNS, Math.max(1, Math.round(width)));
}
/** Full width on small screens; the configured columns from md up. */
export function gridItemSize(width) {
    return { xs: GRID_COLUMNS, md: clampWidth(width) };
}
export function layoutCells(dashboard, widgets) {
    return dashboard.layout.map(function (item, index) {
        var _a, _b;
        var entry = widgets[item.widget];
        return {
            key: "".concat(index, ":").concat(item.widget),
            widgetId: item.widget,
            width: clampWidth(item.width),
            values: (_a = item.values) !== null && _a !== void 0 ? _a : {},
            widget: (_b = entry === null || entry === void 0 ? void 0 : entry.widget) !== null && _b !== void 0 ? _b : null,
            revision: entry === null || entry === void 0 ? void 0 : entry.revision,
            problem: entry ? entry.problem : "missing",
        };
    });
}
